import React, { useEffect, useState } from 'react'

export default function Project_work_distribution() {
    const [workDistribution, setWorkDistribution] = useState([]);
    const [membretype, setMembertype] = useState(false);

    useEffect(() => {
        let memtype = localStorage.getItem('membership_type');
        if (memtype === 'free') {
            setMembertype(true);
        }
        loadProjectDistribution();
    }, []);

    async function loadProjectDistribution() {
        try {
            let com_id = localStorage.getItem('mem_company_id');
            const response = await fetch(
                'getProjectWorkDistribution.php',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        company_id: com_id
                    })
                }
            );
            const data = await response.json();
            setWorkDistribution(data);

        } catch (error) {
            console.log(error);
        }
    }

    return (
        <div>
            <div className='fullwidth pb-30 pull_left'>
                <h3>Project Work Distribution</h3>
                <p>
                    Here you can see the health and
                    resource, workload distribution
                    outline of projects.
                </p>
            </div>
            <div className='vl_listing_row'>
                <div className='vl_dsh_one_full'>
                    <table className='vl_task_table'>
                        <thead>
                            <tr>
                                <th>Project Name</th>
                                <th>Total Hours</th>
                                <th>Members</th>
                                <th>Pending Task</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                workDistribution.length > 0 ? (

                                    workDistribution.map((item, index) => (
                                        <tr key={index}>
                                            <td>
                                                {item.project_name}
                                            </td>

                                            <td>
                                                {item.total_hours}
                                            </td>

                                            <td>
                                                {item.member_count} Members
                                            </td>

                                            <td>
                                                {item.pending_task} Pending
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td
                                            colSpan="4"
                                            style={{
                                                textAlign: 'center',
                                                padding: '30px'
                                            }}
                                        >
                                            No project found
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            {membretype && (
                <div className='vl_dsh_popup activebillpop'>
                    <div className='alertbox'>
                        <div className='alertheader'>
                            <h3><i className='ri-alert-line'></i>Alert</h3>
                        </div>

                        <div className='contentarea'>
                            <p>Please upgrade your membership to access this page</p>
                        </div>
                         <div className='alert_btns'>
                            <button onClick={() => window.history.back()}>Back</button>
                        </div>

                    </div>
                </div>
            )}
        </div>
    )
}